import { createReducer, on } from '@ngrx/store';
import { EstreamPanel } from 'brain-data/model/estream-panel.model';
import {
  loadEstreamPanels,
  loadEstreamPanelsError,
  loadEstreamPanelsSuccess,
} from '../actions/estream-panel.action';

export default interface EstreamPanelState {
  panels: EstreamPanel[];
  loading: boolean;
  loaded: boolean;
  error?: Error;
}

export const initialState: EstreamPanelState = {
  panels: [],
  loading: false,
  loaded: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(loadEstreamPanels, (state): EstreamPanelState => ({ ...state, loading: true, error: undefined })),
  on(loadEstreamPanelsSuccess, (state, { panels }): EstreamPanelState => ({
    ...state,
    panels,
    loading: false,
    loaded: true,
  })),
  on(loadEstreamPanelsError, (state, { error }): EstreamPanelState => ({
    ...state,
    loading: false,
    error,
  })),
);
